module.exports = "/assets/data/9935c6dce34c637e3a93ded1a5bbc724-CF5.data.json";